// CommonModal.tsx
import { Modal } from "antd";

interface CommonModalProps {
  open: boolean;
  onCancel?: () => void;
  onOk?: () => void;
  title: string;
  content?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  children?: React.ReactNode;
  confirmLoading?: boolean;
  footer?: React.ReactNode;
  destroyOnClose?: boolean;
  width?: number | string;
  maskClosable?: boolean;
  keyboard?: boolean;
  bodyStyle?: React.CSSProperties;
  onClose?: () => void;
  wrapClassName?: string;
}

const CommonModal: React.FC<CommonModalProps> = ({
  open,
  onCancel,
  onOk,
  title,
  okText = "OK",
  cancelText = "Cancel",
  children,
  confirmLoading = false,
  footer,
  destroyOnClose = false,
  width = 500,
  maskClosable = false,
  bodyStyle,
  keyboard = false,
  wrapClassName,
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      okText={okText}
      cancelText={cancelText}
      confirmLoading={confirmLoading}
      footer={footer}
      destroyOnClose={destroyOnClose}
      width={width}
      maskClosable={maskClosable}
      keyboard={keyboard}
      closable={false}
      bodyStyle={bodyStyle ?? {}}
      wrapClassName={wrapClassName}
    >
      {children} {/* Render children */}
    </Modal>
  );
};

export default CommonModal;
